import { render, staticRenderFns } from "./followStat.vue?vue&type=template&id=2cc6571f&"
import script from "./followStat.vue?vue&type=script&lang=js&"
export * from "./followStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "followStat.vue"
export default component.exports